<template>
  <div class="vertical_layout height">
    <div class="curRightheader horizontal_layout_no">
      <section class="flex"><p style="padding-top: 5px;">进场订单</p></section>
      <section>
        <div class="curRightSearch">
          <el-form class="demo-ruleForm">
            <el-form-item>
              <el-input v-model="param.orderNum" placeholder="请输入订单编号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="daterange"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select v-model="param.payStatus" placeholder="请选择支付状态">
                <el-option
                  v-for="item in payStatusOptions"
                  :key="item.code"
                  :label="item.status"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom: 5px; margin-right: 0;">
              <div class="projectFiltering" style="padding: 0;">
                <div class="projectFilteringAdd">
                  <div class="horizontal_layout" style="padding-top: 5px;">
                    <el-button v-for="(btn, btnIndex) in searchData" :key="btnIndex" :icon="btn.icon" :class="btn.class" @click="searchEvent(btn)">{{ btn.title }}</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </section>
    </div>
    <div class="curRightBody flex height relative" style="height: calc(100% - 100px)">
      <noDataOrLoading :listData="recordLs" :loading="curLoading" :img-size="65"></noDataOrLoading>
      <el-table class="elTableModule" fixed height="100%" :data="recordLs">
        <el-table-column prop="orderNum" label="进场订单编号" width="200px"></el-table-column>
        <el-table-column prop="nickname" label="用户" width="150px"></el-table-column>
        <el-table-column prop="openTime" label="进场开始时间" width="160px"></el-table-column>
        <el-table-column prop="closeTime" label="进场结束时间" width="160px"></el-table-column>
        <el-table-column prop="animalQuarantineCertNo" label="检疫编号" width="160px"></el-table-column>
        <el-table-column prop="amount" label="检疫数量" width="100px"></el-table-column>
        <el-table-column prop="livestockNum" width="120" label="实际进场数量"></el-table-column>
        <el-table-column prop="butcherTotalPrice" label="金额"></el-table-column>
        <el-table-column label="支付状态">
          <template slot-scope="scope">
            <span>{{ payStatusObj[scope.row.payStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column width="130" label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="interfaceOperation interfaceOperationBlock">
              <p class="edit" @click="checkDetail(scope.row)">查看详情</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paginationEL
      :total="pageTotal"
      :totalStatus="true"
      totalInfo="条"
      :pageCurrent="param.current"
      :pageSize="param.size"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="currentPage"
    ></paginationEL>

    <!-- 订单详情 -->
    <el-dialog
      class="elDialogAdd indexJust"
      :visible.sync="showDialogDetail"
      center
      title="记录详情"
      custom-class="detail-dialog"
      width="650px"
      top="0"
      @close="closeDialog"
      @open="openDialog"
      @opened="openedDialog"
    >
      <el-descriptions v-if="detail" :column="1" border :labelStyle="{ textAlign: 'center' }">
        <el-descriptions-item label="进场订单编号">{{ detail.orderNum }}</el-descriptions-item>
        <el-descriptions-item label="进场开始时间">{{ detail.openTime }}</el-descriptions-item>
        <el-descriptions-item label="进场结束时间">{{ detail.closeTime }}</el-descriptions-item>
        <el-descriptions-item label="屠宰场名称">{{ detail.butcherName }}</el-descriptions-item>
        <el-descriptions-item label="通道名称">{{ detail.lockName }}</el-descriptions-item>
        <el-descriptions-item label="用户">{{ detail.nickname }}</el-descriptions-item>
        <el-descriptions-item label="检疫证明编号">{{ detail.animalQuarantineCertNo }}</el-descriptions-item>
        <el-descriptions-item label="申报数量">{{ detail.amount }}</el-descriptions-item>
        <el-descriptions-item label="实际进场数量">{{ detail.livestockNum }}</el-descriptions-item>
        <el-descriptions-item label="视频回放" contentStyle="width:357px;height:180px;">
          <div class="videoWrapper">
            <!--            <img v-if="errorMsg" width="357" height="180" style="border: 1px solid #ccc" src="../../../../../static/images/noVideo.png" alt="">-->
            <div v-html="videohtml"></div>
            <!--            <video class="myVideoDialog" id="myVideoDialog"></video>-->
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import lang_zhcn from 'video.js/dist/lang/zh-CN.json';
videojs.addLanguage('zh-CN', lang_zhcn);
// import 'videojs-contrib-hls'
// import elCascaderMulti from "el-cascader-multi";
// Vue.use(elCascaderMulti);
import noDataOrLoading from '@/components/module/noDataOrLoading/index.vue';
import paginationEL from '@/components/module/paginationEL/index.vue';
import dialogEL from '@/components/module/dialogEL/index.vue';

import { recordList, recordDetail, getButcherAndLockList } from '@/api/slaughter';
export default {
  props: {
    searchData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    noDataOrLoading,
    paginationEL,
    dialogEL,
  },
  data() {
    return {
      payStatusObj: {
        '0': '支付成功',
        '1': '未支付',
        '2': '待支付',
        '3': '支付失败'
      },
      payStatusOptions: [
        {
          status: '支付成功',
          code: '0'
        },
        {
          status: '未支付',
          code: '1'
        },
        {
          status: '待支付',
          code: '2'
        },
        {
          status: '支付失败',
          code: '3'
        }
      ],
      loading: true,
      recordLs: [],
      daterange: [], // 日期范围
      param: {
        current: 1,
        size: 10,
        lockNo: '', // 通道编号
        orderNum: '',
        payStatus: '',
        startDateTime: '',
        endDateTime: '',
        dateType: 3
      },
      pageTotal: 0,
      showDialogDetail: false,
      detail: null,
      videohtml: '',
      player: null,
      errorMsg: null,
      fuzujianid:{},
      curLoading: false,
    };
    
  },
  mounted() {
    // this.onSearch()
  },
  methods: {
    // 搜索 / 重置 中间
    searchEvent(item, type) {
      switch(item.event) {
        case 'resetForm':
          this.reset();
          break;
        case 'submitForm':
          this.onSearch()
          break;
        default:
          break;
      }
    },
    clickItem(item) {
      if (JSON.stringify(item) === '{}') {
        this.loading = false;
        this.recordLs = [];
        this.pageTotal = 0;
      } else {
        this.fuzujianid=item
        this.param = {
        current: 1,
        size: 10,
        // lockNo: item.lockNo, // 通道编号
        butcherId: this.fuzujianid,
        orderNum: '',
        payStatus: '',
        startDateTime: '',
        endDateTime: '',
        dateType: 3
        };
        this.getRecord();

      }
    },
    getVideo(nowPlayVideoUrl) {
      this.player = videojs('myVideoDialog', {
        width: 357,
        height: 180,
        autoplay: true, // 设置自动播放
        controls: true,
        controlBar: {
          // 设置控制条组件
          // 'currentTimeDisplay':true,
          // 'timeDivider':true,
          // 'durationDisplay':true,
          // 'remainingTimeDisplay':false,
          // volumePanel: {
          //   inline: false,
          // },
          /* 使用children的形式可以控制每一个控件的位置，以及显示与否 */
          children: [
            { name: 'playToggle' }, // 播放按钮
            { name: 'currentTimeDisplay' }, // 当前已播放时间
            { name: 'progressControl' }, // 播放进度条
            { name: 'durationDisplay' }, // 总时间
            { name: 'FullscreenToggle' } // 全屏
          ]
        }
      });
      //关键代码， 动态设置src，才可实现换台操作
      this.player.src([
        {
          // src: 'https://open.ys7.com/v3/openlive/D01333659_1_1.m3u8?expire=1664721425&id=494276186088669184&t=17e5fc31b2dad5b5d04c4ff26a41b9285139fc3ceb5d35435f57b5f6655f5859&ev=100',
          // src: 'http://testvod.yunlansoft.com/sv/86d05f8-1823f35af08/86d05f8-1823f35af08.mp4',
          src: nowPlayVideoUrl,
          type: 'video/mp4' // 告诉videojs,这是一个hls流
        }
      ]);
    },
    reset() {
      (this.param = {
        current: 1,
        size: 10,
        lockNo: '', // 通道编号
        orderNum: '',
        payStatus: '',
        startDateTime: '',
        endDateTime: '',
        dateType: 3
      }),
        (this.daterange = []);
      this.onSearch();
    },
    onSearch() {
      this.param.current = 1;
      this.param.startDateTime = this.daterange && this.daterange.length > 0 ? this.daterange[0] : '';
      this.param.endDateTime = this.daterange && this.daterange.length > 0 ? this.daterange[1] : '';
      this.getRecord();
    },
    checkDetail(item) {
      this.detail = item;
      this.showDialogDetail = true;
    },
    getRecord() {
      this.param.butcherId=this.fuzujianid
      if (this.param.current === 1) {
        this.recordLs = [];
        this.pageTotal = 0;
      }
      this.curLoading = true;
      recordList(this.param).then((res) => {
        this.loading = false;
        this.curLoading = false;
        this.recordLs = res.data.data.page.records;
        this.pageTotal = res.data.data.page.total;
        this.itemKey = Math.random()
      }).catch(() => {
        this.curLoading = false;
      });
    },
    currentPage(e) {
      this.loading = true;
      this.param.current = e;
      this.getRecord();
    },
    handleSizeChange(e) {
      this.param.size = e;
      this.param.current = 1;
      this.loading = true;
      this.getRecord();
    },
    prev(e) {
      this.loading = true;
      this.param.current = e;
      this.getRecord();
    },
    next(e) {
      this.loading = true;
      this.param.current = e;
      this.getRecord();
    },
    closeDialog() {
      this.player.dispose();
      this.videohtml = '';
      this.showDialogDetail = false;
    },
    openDialog() {
      // this.videohtml = '<video id="currentPlayer" class="video-js vjs-big-play-centered  vjs-default-skin " style="width:700px;height:393.75px" muted></video>'
      this.videohtml =
        '<video class="myVideoDialog video-js vjs-big-play-centered  vjs-default-skin" id="myVideoDialog"></video>';
    },
    openedDialog() {
      this.$nextTick((res) => {
        videojs.hook('error', (player, err) => {
          this.errorMsg = err;
          console.log(`player ${player.id()} has errored out with code ${err.code} ${err.message}`);
        });
        setTimeout(() => {
          this.getVideo(this.detail.butcherOrderPlayUrl);
        }, 300);
      });
    },
  }
};
</script>

<style scoped>
/* .back {
  text-align: center;
}
.searchBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detailBLock {
  overflow: hidden;
  width: 100%;
}
.detailBLock > div {
  float: left;
  border-left: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  font-size: 16px;
  line-height: 50px;
  width: calc(100% - 240px);
  text-align: center;
}

.detailBLock:last-child > div {
  height: 50px;
  border-bottom: 1px solid #e5e5e5;
}

.detailBLock > div:nth-child(1) {
  background: #f5f7fa;
  color: #333333;
  width: 200px !important;
  padding-right: 12px;
  text-align: right;
  border-right: none !important;
}
.checkBtn {
  text-decoration: underline;
  color: #666666;
}
.checkBtn:hover {
  color: #00bf30;
}
.videoWrapper {
  position: relative;
  width: 357px;
  height: 180px;
}
.videoWrapper video {
  width: 357px;
  height: 180px;
}
.myVideoDialog {
  position: absolute;
}
/deep/ .detail-dialog {
  border-radius: 10px !important;
}
/deep/ .el-form {
  overflow: inherit !important;
}
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 250px !important;
} */
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/slaughterHouse/components/order.vue